import React from "react";
import { Table } from "react-bootstrap";
import ToggleBar from "../../commoncomponents/toggleBar";
import { utcToReportDate } from "../../../utils/dateConvert";
import { rounding } from "../../../utils/math";
import { downloadCSVFile } from '../../../api/apiClient';
import Location from "../../commoncomponents/location";
import ShowIButtonName from "../../commoncomponents/showIButtonName.js";

function LocationTable(props) {
  let tempAEnabled = props.tempAEnabled;
  let tempBEnabled = props.tempBEnabled;
  let driverIDEnabled = props.driverIDEnabled;
  let assetCustomerName = props.assetCustomerName;
  let timeZone = props.timeZone ? props.timeZone.toString().slice(25, 55) : '';
  const data = (
    <Table responsive striped>
      <thead>
        <tr className="nowwrapTH">
          <th>ID</th>
          <th>Received</th>
          <th>Created</th>
          <th>Sat</th>
          <th>Location</th>

          <th>LogID</th>
          <th>Speed</th>
          <th>Odometer</th>
          <th>Trip</th>
          <th>Ignition</th>

          <th>Duress</th>
          <th>Fridge</th>
          {tempAEnabled && <th>TempA</th>}
          {tempBEnabled && <th>TempB</th>}
          <th>GPS</th>

          <th>GSM</th>
          {driverIDEnabled && <th>Driver ID</th>}
        </tr>
      </thead>
      <tbody>
        {props.locationData.map((element) => {
          return (
            <tr>
              <td>{element.id}</td>
              <td>{utcToReportDate(element.received)}</td>
              <td>{utcToReportDate(element.created)}</td>
              <td>{element.sat}</td>
              <td>
                <Location
                  address={element.location}
                  lat={element.latitude}
                  lng={element.longitude}
                />
              </td>

              <td>{element.logID}</td>
              <td>{rounding(element.speed)}</td>
              <td>{element.odometer}</td>
              <td>{element.trip}</td>
              <td>{element.ignition}</td>

              <td>{element.duress}</td>
              <td>{element.fridge == 1 ? "On" : "Off"}</td>
              {tempAEnabled && <td>{element.tempA}</td>}
              {tempBEnabled &&<td>{element.tempB}</td>}
              <td>{element.gps}</td>

              <td>{element.gsm}</td>
              {driverIDEnabled && <td>
                {element.driverID && 
                <ShowIButtonName 
                  ibuttonId={element.ibuttonId}
                  serialno={element.serialno} 
                  iButtonName={element.iButtonName}
                />}
              </td>}
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
  const handleDownloadExcel = () => {
    downloadCSVFile(props.locationData, "LocationDataReport", assetCustomerName, timeZone);
  }
  return (
    <ToggleBar
      caption="Location And Data"
      icon="fa fa-database"
      color="#A94442"
      content={data}
      download={handleDownloadExcel}
    />
  );
}

export default LocationTable;
